import { createAction, props } from '@ngrx/store';
import { SiteDto } from 'src/app/api/models';

export const loadSiteByCity = createAction(
  '[Site] Load Site by city',
  props<{ cityId: number }>()
);

export const loadSiteByCity_Success = createAction(
  '[Site] Load Site by city Success',
  props<{ data: SiteDto[] }>()
);

export const loadSiteByCity_Failure = createAction(
  '[Site] Load Site by city Failure',
  props<{ error: any }>()
);


export const resetSite = createAction("[Site] Reset");




